"use client";

import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

import { useAccessOrEmpty } from "@/hooks/use-access";
import { canAccessRoute } from "@/config/route-access-config";

export function RouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const access = useAccessOrEmpty();

  useEffect(() => {
    if (!canAccessRoute(location.pathname, access)) {
      navigate("/dashboard", { replace: true });
    }
  }, [access, location.pathname, navigate]);

  return <Outlet />;
}
